import styled from 'styled-components';

export const Underline = styled.hr`
  width: 100%;
  height: 1px;
  margin: 0 0 16px 0;
  background-color: #ccc;
`;
